import { Box, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";
import { parseAndFormateDate } from "../../utils/common";
import { AttachmentOutlined } from "@mui/icons-material";
import { IssueMediaModal } from "./issueMediaModal";

const IssueMsgView = ({ issueType, x }: any) => {
  const [media, setMedia] = useState(false);

  return (
    <>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="flex-end"
        alignItems="center"
        mb={4}
      >
        <Stack>
          <Stack direction="row" alignItems="center">
            <Box>
              <Stack
                mb={0.25}
                direction="row"
                gap={5}
                justifyContent="space-between"
              >
                <Typography
                  variant="body2"
                  sx={{ textTransform: "capitalize", fontSize: "10px" }}
                >
                  {x.updated_by?.split("@")[0]?.split(".")[0]}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "#4D5970", fontSize: "10px" }}
                >
                  {parseAndFormateDate(x?.updated_at_datetime)} - Sent To
                  :&nbsp;
                  {x?.visibility === "internal"
                    ? "Internal Team"
                    : x?.visibility === "techsupport"
                    ? "Tech Team"
                    : "Pharmacy"}
                </Typography>
              </Stack>
              <Box
                sx={{
                  backgroundColor:
                    x.visibility === "internal"
                      ? "#FFF6E7"
                      : x.visibility === "techsupport"
                      ? "#E6EEFF"
                      : "#EAF9F8",
                  borderRadius: 2,
                }}
                px={2}
                py={1}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                  }}
                >
                  <Typography sx={{ whiteSpace: "pre-wrap" }} variant="body2">
                    {x?.text}
                  </Typography>
                  {x.images?.length > 0 ? (
                    <Tooltip title="Attachments">
                      <IconButton
                        size="small"
                        color="primary"
                        onClick={() => setMedia(true)}
                      >
                        <AttachmentOutlined />
                      </IconButton>
                    </Tooltip>
                  ) : null}
                </Box>
              </Box>
            </Box>
          </Stack>
        </Stack>
      </Box>
      {media ? (
        <IssueMediaModal
          open={media}
          onClose={() => setMedia(false)}
          activeLocationId=""
          uploadType="issue"
          uploadedFiles={x.images}
          setUploadedFiles={null}
          mode="view"
          issueType={issueType}
        />
      ) : null}
    </>
  );
};

export default IssueMsgView;
